class CareerForm {
  constructor() {
    this.container = document.querySelector('.career-form')
    if (this.container) {
      this.init()
    }
  }
  init() {
    this.container.addEventListener("submit", (ev) => {
      ev.preventDefault()
      ev.target.style.display = 'none'
      if (this.validateFields()) {
        this.submitForm()
      }
    })
  }

  validateFields() {
    let inputs = this.container.querySelectorAll('input')
    let errorMsg = this.container.querySelector(".career-form__error-msg");
    let result = false
    inputs.forEach(input => {
      if (input.length != 0 ) {
        errorMsg.style.display = 'none';
        result = true;
      } else {
        errorMsg.style.display = 'flex';
        result = false;
      }
    });
    return result;
  }

  submitForm() {
    let message = this.container.querySelector(".career-form__success-msg");
    let fieldsContainer = this.container.querySelector(".career-form__input-container");
    let form = this.container.querySelector('.career-form__container form')
    window.getToken = async () => {
      return await fetch("/!/DynamicToken/refresh")
        .then((res) => res.json())
        .then((data) => {
          return data.csrf_token;
        })
        .catch((error) => {
          this.error = "Something went wrong. Please try again later.";
        });
    };
    window.sendForm = async () => {
      const token = await getToken();
      let tokeninputs = document.querySelectorAll('form input[name="_token"]');
      tokeninputs.forEach((item) => {
        item.value = token;
      });
    };
    fetch(form.action, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
      method: "POST",
      body: new FormData(form),
    }).then((response) => {
      if (response.status == 200) {
        fieldsContainer.classList.add("hidden");
        message.style.display = 'flex';
      }
    });
  }
}

export default CareerForm;